export default class Type {
  static isString(target) {
    return Object.prototype.toString.call(target) === '[object String]';
  }
}



// WEBPACK FOOTER //
// ./src/util/type.js